<template>
	<div id="page">

		<Header></Header>

		<div id="banner">
			<img :src="imgPrefix + 'static/about_banner.jpg'" class="pcShow" />
			<img :src="imgPrefix + 'static/mobile_about_banner.jpg'" class="mobileShow" />
		</div>

		<div id="about">
			<div class="container">
				<div class="about">
					<div class="title">关于我们</div>
					<div class="txt">
						<p>惠州得胜彩印有限公司创建于1984年， 30多年来始终专注于印刷领域，目前已成为国内众多知名品牌企业值得信任的供应商。</p>
						<p>超过200位专业技术人员服务于得胜彩印各个业务领域，产品涵盖各类精品盒、包装盒、手提纸袋、精装画册、宣传彩页、产品说明书、纸箱、展柜等。</p>
						<p class="pcShow">拥有先进的德国、日本进口印刷设备，可提供集设计、制版、印刷、装订和后道加工为一体的一站式全方位服务。</p>
						<p class="pcShow">强大的研发设计团队，通过不断探索和钻研各种物料和结构的可塑性，结合完善的生产程序及品质管理系统，不断满足市场需求。</p>
						<p class="mobileShow">拥有先进的德国、日本进口印刷设备，可提供集设计、制版、印刷、装订和后道加工为一体的一站式全方位服务。强大的研发设计团队，通过不断探索和钻研各种物料和结构的可塑性，结合完善的生产程序及品质管理系统，不断满足市场需求。</p>

					</div>
					<img class="pcShow" :src="imgPrefix + 'static/company.jpg'" />
					<img class="mobileShow" :src="imgPrefix + 'static/mobile_company.jpg'" />
				</div>

				<div class="about2" id="culture">
					<div class="title pcShow">打造实力派一站式印制服务商</div>
					<div class="sub_title pcShow">
						<span>优质品质</span>
						<span>专业专注</span>
						<span>诚信创新</span>
					</div>

					<ul class="pcShow">
						<li class="li-f">
							<div class="icon"><img :src="imgPrefix + 'static/about_icon1.jpg'"></div>
							<div class="txt2">
								<p class="p1">企业宗旨</p>
								<p class="p2">以成熟的技术和可靠的产品质量<br>
								服务客户，贡献社会，发展自己</p>
							</div>
						</li>
						<li class="li-s">
							<div class="icon"><img :src="imgPrefix + 'static/about_icon2.jpg'"></div>
							<div class="txt2">
								<p class="p1">企业要求</p>
								<p class="p2">奉献优质产品<br>
								为客户利益不断创新</p>
							</div>
						</li>
						<li class="li-l">
							<div class="icon"><img :src="imgPrefix + 'static/about_icon3.jpg'"></div>
							<div class="txt2">
								<p class="p1">文化理念</p>
								<p class="p2">高效 创新 诚信 共赢</p>
							</div>
						</li>
					</ul>
				</div>
			</div>

			<img class="mobileShow" style="width: 100%;" :src="imgPrefix + 'static/mobile_fw.jpg'" />
			<img class="mobileShow" style="width: 100%;" :src="imgPrefix + 'static/mobile_zz2.jpg'" />

			<div class="iso" id="iso">
				<div class="container">
					<div class="title">ISO 三体系认证证书</div>
					<ul class="ul1">
						<li>
							<img :src="imgPrefix + 'static/zhengshu_01.jpg'">
						</li>
						<li>
							<img :src="imgPrefix + 'static/zhengshu_02.jpg'">
						</li>
						<li>
							<img :src="imgPrefix + 'static/zhengshu_03.jpg'">
						</li>
					</ul>
				</div>
			</div>

			<div class="zs2">
				<div class="container">
					<ul>
						<div>
						<li>
							<p>GSV反恐证书</p>
							<img :src="imgPrefix + 'static/zhengshu_05.jpg'">
						</li>
						</div>
					</ul>
				</div>
			</div>

			<div class="container">
				<div class="customer" id="customer">
					<div class="title">合作客户</div>
					<img class="pcShow" :src="imgPrefix + '/static/partner.jpg'">
					<img class="mobileShow" :src="imgPrefix + 'static/mobile_partner.jpg'">
				</div>
			</div>
		</div>

		<Footer></Footer>

	</div>
</template>

<script>
	import Header from '../components/Header.vue';
	import Footer from '../components/Footer.vue';
  import {getProductCategoryList, getProductList} from "../axios/api";
	export default {
    data() {
      return {
        imgPrefix: process.env.PREFIX_IMG,
      }
    },
		components: {
			Header,
			Footer
		},
    watch: {
      $route() {
        this.$nextTick(() => { this.getAboutAnchor()});
      }
    },
    created(){
      this.$nextTick(() => { this.getAboutAnchor()});
    },
		mounted() {
      this.$nextTick(function () {
        window.addEventListener('scroll', this.handleScroll)
      })

		  $("#nav ul li:nth-child(5) a.parent").addClass("router-link-exact-active")
		},
    methods: {
      getAboutAnchor(){
        let select = localStorage.getItem("anchorId");
        let elm = document.getElementById(select);
        if (select && elm) {
          elm.scrollIntoView(true);
          localStorage.setItem('anchorId', '')
        }
      }
    }
	}
</script>

<style>
	#about .about{
		text-align: center;
	}
	#about{
		margin: 90px 0;
	}
	.about .title{
		font-size: 48px;
		color: #333333;
		position: relative;
		padding-bottom: 20px;
		letter-spacing: 2px;
		margin-bottom: 38px;
	}
	.about .title::after{
		content: '';
		position: absolute;
		height: 4px;
		width: 70px;
		background: #ff6600;
		left: 50%;
		margin-left: -35px;
		bottom: 0;
	}
	.about img{
		width: 100%;
	}
	#about .txt{
		font-size: 16px;
		color: #666666;
		line-height: 29px;

	}
	#about .txt p{
		margin-bottom: 25px;
	}
	#about .txt p:first-of-type{
		margin-bottom: 0;
	}
	#about .txt p:nth-of-type(3){
		margin-bottom: 0;
	}
	#about .txt{
		margin-bottom: 65px;
	}
	.about2{
		min-height: 0;
		overflow: hidden;
		padding: 85px 0;
	}
	.about2 ul li{
		/* width: 33.333%;
		float: left; */
		display: table-cell;
	}
	.about2 ul li .icon{
		float: left;
	}
	.about2 .title{
		text-align: center;
		font-size: 40px;
		color: #666666;
		letter-spacing: .5px;
		margin-bottom: 30px;
	}
	.about2 .sub_title{
		text-align: center;
		font-size: 22px;
		color: #666666;
		margin-bottom: 85px;
		letter-spacing: 1px;
	}
	.about2 .sub_title span{
		background: url('https://img.ds-cy.com/static/check.jpg') no-repeat;
		text-indent: 33px;
		display: inline-block;
		line-height: 28px;
		margin: 0 25px;
	}
	.about2 ul{
		width: 92%;
		margin-left: 4%;
		min-height: 0;
		overflow: hidden;
		padding-bottom: 110px !important;
		/* display: flex; */
		border-bottom: 2px dashed #ddd;
		display: table;
	}
	.about2 ul li .icon{
		margin-left: 50px;
		margin-right: 20px;
	}
	/* .about2 ul li.li-s{
		margin-left: 55px;
	} */
	.about2 ul li .p1{
		color: #333333;
		font-size: 24px;
		margin-bottom: 10px;
		padding-top: 3px;
	}
	.about2 ul li .p2{
		color: #666666;
		font-size: 15px;
	}
	.iso{
		width: 92%;
		margin-left: 4%;
		min-height: 0;
		overflow: hidden;
		padding-bottom: 78px;
		/* border-bottom: 2px dashed #ddd; */
	}

	.iso ul li{
		width: 33.333%;
		display: block;
		text-align: center;
		float: left;
	}
	.iso ul{
		min-height: 0;
		overflow: hidden;
		/* display: flex; */
	}
	.iso .title{
		width: 100%;
		text-align: center;
		font-size: 42px;
		color: #666666;
		margin-bottom: 70px;
	}
	.customer{
		text-align: center;
		padding-top: 75px;
	}
	.customer img{
		width: 100%;
	}
	.customer .title{
		font-size: 42px;
		margin-bottom: 40px;
		color: #666666;
	}
	/* .ul1{
		padding-bottom: 65px !important;
		margin-bottom: 65px !important;
		border-bottom: 2px dashed #ddd;
	}
	.ul2{
		width: 840px;
		margin: auto;
	}
	.ul2 li{
		width: 420px !important;
	}

	.ul2 p{
		font-size: 40px;
		color: #666666;
	} */
	.zs2{

		margin: auto;
		min-height: 0;
		overflow: hidden;
	}
	.zs2 ul{
		border-bottom: 2px dashed #ddd;
		border-top: 2px dashed #ddd;
		min-height: 0;
		overflow: hidden;
		width: 1260px;
		margin: auto;
		padding: 68px 0 !important;
	}

	.zs2 ul li{
		width: 310px;
		/* float: left; */
		text-align: center;
		display: inline-block;
	}
	.zs2 ul li.last-li{
		float: right;
	}
	.zs2 ul li p{
		font-size: 40px;
		color: #666666;
	}
	.zs2 ul div{
		width: 740px;
		margin: auto;
		text-align: center;
	}

	@media (max-width:1199px) {
		.about2 ul li .icon {
		    margin-left: 0px;
		    margin-right: 14px;
		}
		.about2 ul li .p1 {
		    font-size: 20px;
		    margin-bottom: 5px;
		    padding-top: 0px;
		}
		.about2 ul li .icon img{
			width: 78px;
		}
	
		.about2 ul li .p2{
			font-size: 13px;
		}
		.iso ul li img{
			width: 90%;
		}
		.zs2 ul{
			width: 100%;
		}
		.zs2 ul li p{
			font-size: 32px;
		}
		.iso .title{
			width: 100%;
			font-size: 34px;
		}
		.customer .title{
			font-size: 35px;
			margin-bottom: 35px;
		}
		.about2 .title{
			font-size: 35px;
		}
		.about2 .sub_title{
			font-size: 19px;
		}
		.about .title{
			font-size: 40px;
		}
	}

	@media (max-width:991px) {
		.about2 ul li{
			display: block;
			width: 33.333%;
			float: left;
			text-align: center;
		}
		.about2 ul li .txt2{
			width: 100%;
			display: block;
		}
		.about2 ul li .icon{
			margin: auto;
			margin-bottom: 10px;
			width: 100%;
		}
		.about2 .sub_title{
			margin-bottom: 70px;
		}
		.about2 ul{
			padding-bottom: 75px !important;
		}
		.zs2 ul li img{
			width: 100%;
		}
		.zs2 ul li:last-child{
			margin-right: 4%;
		}
	}

	@media (max-width:767px) {
		.zs2 ul li:last-child{
			margin-right: 0;
		}
		.zs2 ul{
			border-top: 0;
		}
		.zs2 ul{
			width: 100%;
		}
		.zs2 ul div{
			width: 90%;
		}
		.zs2 ul li{
			width: 46%;
		}
		.zs2 ul li p{
			font-size: 18px;
		}
		.zs2 ul li img{
			width: 100%;
		}
		.zs2 ul{
			padding: 35px 0 !important;
		}
		/* .iso{
			background: #fff !important;
		}
		.iso ul.ul1{
			background: #eeeeee;
		}
		.iso ul.ul2{
			background: #fff;
			width: 100%;
		}
		.iso ul li{
			width: 48% !important;
		} */
		#about{
			margin: 30px 0;
		}
		.about .title{
			font-size: 26px;
			padding-bottom: 12px;
			margin-bottom: 20px;
		}
		#about .txt {
		    font-size: 15px;
		    line-height: 24px;
		    text-align: left;
			margin-bottom: 20px;
		}
		.about .title::after {
		    height: 3px;
		    width: 50px;
		    margin-left: -25px;
		}
		#about .txt p {
		    margin-bottom: 10px;
			margin-bottom: 10px;
			    text-indent: 30px;
		}
		#about .txt p:first-of-type{
			margin-bottom: 10px;
		}
		#about .txt p:nth-of-type(3){
			margin-bottom: 10px;
		}
		.about2{
			padding: 25px 0;
			padding-bottom: 0;
		}
		.about2 ul{
			border: none;
			width: 100%;
			margin-left: 0;
		}
		.about2 ul li {
		    margin-right: 0 !important;
		    width: 33.333%;
			text-align: center;
		}
		.about2 ul li .icon{
			margin-left: 0;
		}
		.iso ul li{
			width: 35%;
			float: initial;
		}
		.iso ul li img{
			width: 100%;
		}
		.iso{
			padding-bottom: 40px;
			border: none;
			background: #eeeeee;
			width: 100%;
			margin-left: 0;
			padding-top: 30px;
		}
		.iso .title{
			font-size: 24px;
			margin-bottom: 20px;
			text-indent: -7px;
		}
		.customer{
			padding-top: 30px;
		}
		.customer .title{
			font-size: 24px;
			margin-bottom: 20px;
		}
		.iso ul{
			white-space: nowrap;
			overflow-x: scroll;
			width: 100%;
			display: block;
			padding-right: 0;
		}
		.iso ul li{
			display: inline-block;
			white-space: initial;
			width: 162px;
			margin-right: 7px;
		}
		.iso .container{
			padding-right: 0;
		}
	}
	@media (max-width:400px) {
		.iso ul li{
			width: 150px;
		}
	}
</style>




// WEBPACK FOOTER //
// src/page/about.html.vue